import { apiClient } from "./api";

export interface SystemHealth {
  status: "healthy" | "degraded" | "unhealthy";
  timestamp: string;
  uptime: number;
  database: {
    status: "connected" | "disconnected" | "error";
    responseTime: number;
    activeConnections: number;
  };
  performance: {
    memoryUsage: {
      used: number;
      total: number;
      percentage: number;
    };
    cpuUsage: number;
    activeRequests: number;
  };
  services: {
    database: boolean;
    storage: boolean;
    email: boolean;
  };
}

export interface DatabaseHealth {
  status: "healthy" | "degraded" | "unhealthy";
  responseTime: number;
  activeConnections: number;
  totalQueries: number;
  slowQueries: number;
  errors: number;
}

export interface PerformanceMetrics {
  memory: {
    heapUsed: number;
    heapTotal: number;
    external: number;
    rss: number;
  };
  uptime: number;
  nodeVersion: string;
  platform: string;
  arch: string;
}

// Health API service
export const healthApi = {
  // Get overall system health
  async getSystemHealth(): Promise<SystemHealth> {
    return apiClient.get<SystemHealth>("/health");
  },

  // Get database health specifically
  async getDatabaseHealth(): Promise<DatabaseHealth> {
    return apiClient.get<DatabaseHealth>("/health/database");
  },

  // Get performance metrics (requires auth)
  async getPerformanceMetrics(): Promise<PerformanceMetrics> {
    return apiClient.get<PerformanceMetrics>("/health/performance");
  },
};
